function descriptorsListController(userService, $uibModal) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.editMode = false;
    ctrl.hasEditDescriptors = userService.hasEditDescriptors();
  };
  
  ctrl.$onChanges = changes => {
    ctrl.sanctionedExists = false;
    ctrl.hwHasSanctioned = false;
    ctrl.validExists = false;
    ctrl.engineeringExists = false;
    ctrl.checkSwStatuses();
  };

  ctrl.enableEdit = () => {
    ctrl.editMode = true;
  };

  ctrl.checkSwStatuses = () => {
    ctrl.sanctionedExists = ctrl.module.sw_revision.some(({ status }) => status === 'Sanctioned');
    ctrl.hwHasSanctioned = ctrl.module.hw_revision.some(({ status }) => status === 'Sanctioned');
    ctrl.validExists = ctrl.module.sw_revision.some(({ status }) => status === 'Valid');
    ctrl.engineeringExists = ctrl.module.sw_revision.some(({ status }) => status === 'Engineering');
  }

  ctrl.updateDescriptor = event => {
    ctrl.checkSwStatuses();
    ctrl.onUpdate({
      $event: {
        descriptor: event.descriptor,
      },
    });
  };

  ctrl.deleteDescriptor = event => {
    const modalInstance = $uibModal.open({
      templateUrl: '/modules/modals/delete-descriptor-confirmation-modal.html',
      controller: 'deleteDescriptorModalController',
      backdrop: 'static',
      resolve: {
        descriptorItem: function () {
          return event;
        },
      },
    });

    modalInstance.result.then(
      () => {
        // User pressed 'Yes' in the modal.
        ctrl.onDelete({
          $event: {
            type: event.type,
            descriptor: event.descriptor,
          },
        });
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };
}

angular
  .module('package-management.module')
  .controller('descriptorsListController', descriptorsListController);
